@let _optionGroup = optionGroup()!;
@if (showMarketHelp) {
    <ms-market-help [optionGroup]="_optionGroup" [eventHelpText]="eventHelpText" />
}
<div
    class="bet-builder-over-under-container option-group-container double"
    [style.--option-group-rows]="visibleRows()"
    [ngClass]="{ 'ht-of-single-row-options': !showMoreLessButtonVisible && isSingleRowOfOptions() }">
    <ng-container *rxFor="let group of visibleOptionGroups$; trackBy: trackGroup">
        @for (option of group.options; track trackOption($index, option)) {
            <ms-bet-builder-option
                [option]="option"
                [tracking]="{ source: tracking }"
                [optionGroup]="_optionGroup"
                [event]="event"
                [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
                [sourceOfPick]="sourceOfPick" />
        }
    </ng-container>
</div>
@if (showMoreLessButtonVisible) {
    <div class="show-more-less-button right-icon" [ngClass]="{ expanded: expanded }" (click)="onShowMoreLessButtonToggle()">
        {{ expanded ? sitecore.event.ShowLess : sitecore.event.ShowMore }}
        <vn-icon name="theme-right" size="12" />
    </div>
}
